<template>
  <img src="/images/upm.svg" alt="upm logo" />
</template>
